import { Injectable, inject } from '@angular/core';
import { SentryService } from '@shared-lib/services/sentry.service';
import { SkippableErrorHandlerModel } from './skippable-error-handler.interface';

@Injectable({ providedIn: 'root' })
export class SentryErrorHandler implements SkippableErrorHandlerModel {
  private readonly sentryService = inject(SentryService);

  handleError(error: { originalError?: unknown }): false | void {
    this.sentryService.captureError(error.originalError ?? error);
  }
}
